export const sizeErrorMessage = 'Please select a size of your sample.';
export const mockupErrorMessage = 'Oops! First you need to mockup the product as if you are placing your order';